import { useSetQuestionDisLikeMutation } from './mobile/qna.gql.impl';

interface Props {
  onSuccess: () => void;
}
const useSetQuestionDisLike = ({ onSuccess }: Props) => {
  const { mutate: setDisLikeQuestionMutate } = useSetQuestionDisLikeMutation({
    onSuccess,
  });

  return {
    setDisLikeQuestionMutate,
  };
};

export default useSetQuestionDisLike;
